<template>
  <div class="bg-color-light position-relative" style="overflow: hidden">
    <vue-headful :title="doctitle" />
    <b-container>
      <b-row>
        <b-col cols="12" lg="10" offset-lg="1" style="z-index: 10">
          <div class="mb-4 mt-5">
            <h1>Host an Øredev side event</h1>
          </div>
          <div>
            <h3>About Øredev+</h3>
            <p>
              Øredev+ opens the door for the broader Malmö community to engage
              with Øredev, transforming the city into a dynamic hub for diverse
              events. From hackathons to networking sessions, workshops,
              seminars, and more, Øredev+ offers a chance for everyone to
              participate in our vibrant program and share in the Øredev
              experience.
            </p>
            <p></p>
            <p>
              WHY ØREDEV+ <br />
              Hosting an Øredev+ event offers a valuable opportunity to boost
              your company's visibility during Øredev. By leveraging the Øredev
              brand and promoting your event through our media channels, you'll
              gain exposure and become an essential component of the official
              Øredev program, increasing your brand's visibility.
            </p>
          </div>

          <div class="text-center mb-5 mt-5">
            <b-img
              class="text-center"
              fluid
              src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712254780/2024/blue_dots.png"
            ></b-img>
          </div>

          <div class="mb-5 mt-5">
            <h3>Timeline</h3>
            <b-row class="timeline-row">
              <b-col cols="3" lg="2" class="timeline-col-left">
                <div class="blue-border-box two-line">
                  Tue, <br class="d-lg-none" />
                  5th Nov
                </div>
              </b-col>
              <b-col cols="9" lg="10" class="timeline-col-right">
                <div class="blue-striped-box one-line">Øredev+ (all day)</div>
              </b-col>
            </b-row>
            <b-row class="timeline-row">
              <b-col cols="3" lg="2" class="timeline-col-left">
                <div class="blue-border-box two-line">
                  Wed, <br class="d-lg-none" />6th Nov
                </div>
              </b-col>
              <b-col cols="9" lg="10" class="timeline-col-right">
                <div class="blue-bg-box two-line">
                  Øredev Developer Conference<br class="d-lg-none" />
                  (all day)
                </div>
              </b-col>
            </b-row>
            <b-row class="timeline-row">
              <b-col cols="3" lg="2" class="timeline-col-left">
                <div class="blue-border-box two-line">
                  Thu, <br class="d-lg-none" />7th Nov
                </div>
              </b-col>
              <b-col cols="5" lg="7" class="timeline-col-middle">
                <div class="blue-bg-box three-line">
                  Øredev Developer<br class="d-lg-none" />
                  Conference<br class="d-lg-none" />
                  (8am-6pm)
                </div>
              </b-col>
              <b-col cols="4" lg="3" class="timeline-col-right">
                <div class="blue-striped-box two-line">
                  Øredev+<br class="d-lg-none" />
                  (6pm-late)
                </div>
              </b-col>
            </b-row>
            <b-row class="timeline-row">
              <b-col cols="3" lg="2" class="timeline-col-left">
                <div class="blue-border-box two-line">
                  Fri, <br class="d-lg-none" />8th Nov
                </div>
              </b-col>
              <b-col cols="5" lg="6" class="timeline-col-middle">
                <div class="blue-bg-box three-line">
                  Øredev Developer<br class="d-lg-none" />
                  Conference<br class="d-lg-none" />
                  (8am-4pm)
                </div>
              </b-col>
              <b-col cols="4" lg="4" class="timeline-col-right">
                <div class="blue-striped-box two-line">
                  Øredev+ <br class="d-lg-none" />(4pm-late)
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="mb-5 mt-5">
            <h3>Categories</h3>
            <b-row class="mb">
              <b-col cols="6" md="3" class="category-col-top-left">
                <div class="category-card" style="background-color: #2f71d0">
                  <p class="category-card-header">KNOWLEDGE</p>
                  <p>
                    Seminar <br />
                    Tech talk <br />
                    Presentations <br />
                    Panel <br />
                    Demo
                  </p>
                </div>
              </b-col>
              <b-col cols="6" md="3" class="category-col-top-right">
                <div class="category-card" style="background-color: #e34407">
                  <p class="category-card-header">INTERACT</p>
                  <p>
                    Hackathon <br />
                    Workshop <br />
                    Code Retreat <br />
                    Code Review
                  </p>
                </div>
              </b-col>
              <b-col cols="6" md="3" class="category-col-bottom-left">
                <div class="category-card" style="background-color: #f9aa41">
                  <p class="category-card-header">ENTERTAINMENT</p>
                  <p>
                    Film <br />
                    Game night<br />
                    Tour <br />
                    Sports <br />
                    Quiz <br />
                    Live-podcast
                  </p>
                </div>
              </b-col>
              <b-col cols="6" md="3" class="category-col-bottom-right">
                <div class="category-card" style="background-color: #3f875d">
                  <p class="category-card-header">NETWORKING</p>
                  <p>
                    Meetup <br />
                    After-work <br />
                    Party <br />
                    Brunch <br />
                    Open-office <br />
                  </p>
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="mb-5 mt-5">
            <h3>Terms of conditions</h3>
            <b-row class="mt-3">
              <b-col cols="12" lg="6">
                <p class="mb-0" style="font-weight: 400">What you get</p>
                <ul>
                  <li>Event listed on Øredev conference side event page</li>
                  <li>
                    Registration button linking to your own registration page
                  </li>
                  <li>Mention of your Øredev+ event on our social channels</li>
                  <li>Mention of your Øredev+ event in our Newsletter</li>
                  <li>
                    Øredev will invite everyone with a valid Øredev 2024 ticket
                    to attend/register to your Øredev+ event
                  </li>
                  <li>
                    Media kit provided to be used in all mention of side event
                    by Partner including:
                  </li>
                  <ul>
                    <li>Øredev+ event logo</li>
                    <li>Official Øredev+ banner</li>
                    <li>Social media cards</li>
                  </ul>
                </ul>
              </b-col>
              <b-col cols="12" lg="6">
                <p class="mb-0" style="font-weight: 400">What you provide</p>
                <ul>
                  <li>
                    An assigned responsible person at your company handling all
                    inquiries regarding the event before, during and after.
                  </li>
                  <li>
                    Ensure Øredev+ logo is displayed alongside overall event
                    communication and Øredev conference is mentioned in all
                    communication around the side event.
                  </li>
                  <li>
                    Sends a minimum of 5x event photographs on the day of the
                    Øredev+ event.
                  </li>
                  <li>
                    Within 5 working days after the side event, Partner
                    provides:
                  </li>
                  <ul>
                    <li>Number of attendees</li>
                    <li>
                      A full list of company names and job titles of side event
                      participants
                    </li>
                    <li>
                      A quote from the organizer about the benefits of hosting
                      your event as an Øredev+ event
                    </li>
                  </ul>
                </ul>
              </b-col>
            </b-row>
          </div>

          <div class="text-center mb-5 mt-5">
            <b-img
              class="text-center"
              fluid
              src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712254780/2024/green_dots.png"
            ></b-img>
          </div>

          <div class="mb-5 mt-5">
            <h3>How to host an Øredev+</h3>
            <b-row>
              <b-col class="host-col-top-left" cols="6" md="3">
                <div class="host-card" style="background-color: #2f71d0">
                  <p class="text-light">
                    <b-img
                      class="host-icon"
                      src="https://res.cloudinary.com/oredev/image/upload/v1716456908/2024/Oredev%2B/emoji_light_bulb.png"
                    ></b-img
                    ><br />
                    Submit your idea by filling out the form
                  </p>
                </div>
              </b-col>
              <b-col class="host-col-top-right" cols="6" md="3">
                <div class="host-card" style="background-color: #e34407">
                  <p class="text-light">
                    <b-img
                      class="host-icon"
                      src="https://res.cloudinary.com/oredev/image/upload/v1716456919/2024/Oredev%2B/emoji_chat_bubble.png"
                    ></b-img
                    ><br />
                    We'll get in touch <br />
                    with you.
                  </p>
                </div>
              </b-col>
              <b-col class="host-col-bottom-left" cols="6" md="3">
                <div class="host-card" style="background-color: #3f875d">
                  <p class="text-light">
                    <b-img
                      class="host-icon"
                      src="https://res.cloudinary.com/oredev/image/upload/v1716456918/2024/Oredev%2B/emoji_envelope.png"
                    ></b-img
                    ><br />
                    You'll receive everything you'll need from us.
                  </p>
                </div>
              </b-col>
              <b-col class="host-col-bottom-right" cols="6" md="3">
                <div class="host-card" style="background-color: #de9fc2">
                  <p class="text-light">
                    <b-img
                      class="host-icon"
                      src="https://res.cloudinary.com/oredev/image/upload/v1716456864/2024/Oredev%2B/emoji_heart_eyes.png"
                    ></b-img
                    ><br />
                    Ready to roll
                  </p>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-row class="mt-5 mb-3">
            <b-col cols="12" md="6" offset-md="3">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdEs6U5zCgKI3fcTpK8tu97Frz_nSVLoci_MXzV7-z7Xkhw7w/viewform?usp=sf_link"
              >
                <button class="survey-btn">Submit your Øredev+ here!</button>
              </a>
            </b-col>
          </b-row>

          <div class="mb-5 text-center survey-btn-info">
            <p>
              >>>>DEADLINE TO SUBMIT YOUR ØREDEV+ IDEA IS August
              31st.&lt;&lt;&lt;&lt;
            </p>
            <p>
              When submitting your idea, you agree to the terms & conditions
              stated on this page and to our
              <a
                ><router-link to="/code-of-conduct" class
                  >Code of conduct</router-link
                > </a
              >.
            </p>
          </div>
        </b-col>
        <b-img
          class="position-absolute d-none d-lg-block"
          style="width: 11%; left: 5%; top: 19%; z-index: 0"
          src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712254780/2024/yellow_circles.png"
        ></b-img>
        <!-- Pink arrow -->
        <b-img
          class="position-absolute d-none d-lg-block"
          style="width: 11%; left: 7%; top: 85%; z-index: 0"
          src="https://res.cloudinary.com/oredev/image/upload/v1712152461/2024/pink_arrow.png"
        ></b-img>
        <!-- green square of dots-->
        <b-img
          class="position-absolute d-none d-lg-block"
          style="width: 9%; right: 5%; top: 7%; z-index: 0"
          src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712254780/2024/green_box.png"
        ></b-img>
        <!-- blue yellow circle-->
        <b-img
          class="position-absolute d-none d-lg-block"
          style="width: 10%; right: -4%; top: 50%; z-index: 0"
          src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712048064/2024/Asset_6.png"
        ></b-img>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "OredevPlus",
  data() {
    return {
      doctitle: "Øredev+ - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only --->
<style lang="scss" scoped>
@import "../styles/variables.scss";

h1 {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-weight: 500;
  font-size: 32px;
}
h3 {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-weight: 500;
  font-size: 20px;
}
p {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  color: $text-dark;
  font-weight: 300;
  font-size: 19px;
}

.timeline-col-left {
  padding: 3px 3px 3px 15px;
}
.timeline-col-middle {
  padding: 3px 3px 3px 3px;
}
.timeline-col-right {
  padding: 3px 15px 3px 3px;
}

.blue-border-box,
.blue-striped-box,
.blue-bg-box {
  width: 100%;
  height: 39px;
  color: #2f71d0;
  text-align: center;
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 39px;
  border-radius: 5px;
  @media screen and (max-width: 576px) {
    font-size: 15px;
  }
  @media screen and (max-width: 991px) {
    height: 66px;
    line-height: 19px;
  }
}
.blue-border-box {
  border: solid #2f71d0 2px;
}
.blue-striped-box {
  font-weight: 500;
  border: dashed #2f71d0 2px;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1716456855/2024/Oredev%2B/blue_striped_bg.png");
}
.blue-bg-box {
  color: #ffffff;
  background-color: #2f71d0;
}

@media screen and (max-width: 991px) {
  .one-line {
    padding: 21px;
    font-size: 19px !important;
  }
  .two-line {
    padding-top: 11px;
  }
  .three-line {
    padding-top: 3px;
  }
}

.category-card {
  width: 100%;
  height: 237px;
  border-radius: 5px;
}
.category-card p {
  padding-left: 12.15px;
  font-weight: 300;
  font-size: 16px;
  color: #ffffff;
  line-height: 29px;
}
.category-card-header {
  font-weight: 500 !important;
  padding-top: 9.56px;
  margin-bottom: 8px;
}

li {
  font-weight: 300;
  font-size: 19px;
}

// Check marks as embedded bullet points
ul ul {
  list-style-type: none; /* Remove default disc bullets */
  padding-left: 1em; /* Ensure proper indentation */
}
ul ul li {
  position: relative; /* Necessary for absolute positioning of the check mark */
  padding-left: 1.2em; /* Space for the check mark */
}
ul ul li::before {
  content: "\2713"; /* Unicode for check mark */
  position: absolute; /* Position relative to the li */
  left: 0; /* Align check mark to the left */
  top: 0.1em; /* Slight adjustment to align vertically with the first line of text */
}

.host-col-top-left,
.category-col-top-left {
  padding: 8px 3.75px 0px 15px;
}
.host-col-top-right,
.category-col-top-right {
  padding: 8px 7.5px 0px 11.25px;
}
.host-col-bottom-left,
.category-col-bottom-left {
  padding: 8px 11.25px 0px 7.5px;
}
.host-col-bottom-right,
.category-col-bottom-right {
  padding: 8px 15px 0px 3.75px;
}

.host-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 154px;
  border-radius: 5px;
}

.host-icon {
  width: 32px;
  margin-bottom: 8px;
}

.host-card p {
  text-align: center;
  width: 97%;
  margin: auto;
  font-weight: 300;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
}

.survey-btn {
  height: 42px;
  background: #f9aa41;
  border: none;
  border-radius: 30px;
  width: 100%;
  color: $text-dark !important;
  font-weight: 400;
  font-size: 20px;
  line-height: 25.2px;
}
.survey-btn:hover {
  background: #d89338 !important;
}

.survey-btn-info p {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  .host-col-top-left,
  .category-col-top-left {
    padding: 4px 4px 4px 15px;
  }
  .host-col-top-right,
  .category-col-top-right {
    padding: 4px 15px 4px 4px;
  }
  .host-col-bottom-left,
  .category-col-bottom-left {
    padding: 4px 4px 0px 15px;
  }
  .host-col-bottom-right,
  .category-col-bottom-right {
    padding: 4px 15px 0px 4px;
  }
  .survey-btn {
    font-weight: 400;
    font-size: 16px;
    line-height: 20.16px;
  }
}

@media screen and (max-width: 991px) {
  /* .timeline-col-left,
  .timeline-col-middle {
    padding-bottom: 8px;
  }
  .timeline-row {
    margin-bottom: 24px;
  }
  .blue-border-box,
  .blue-bg-box,
  .blue-striped-box {
    height: 33px;
    font-size: 16px;
    line-height: 33px;
  } */
  .category-card {
    height: 190px;
  }
  .category-card p {
    padding-left: 9.43px;
    font-size: 14px;
    line-height: 20px;
  }
  .category-card-header {
    padding-top: 7.67px;
  }
  .host-card p {
    width: 76%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/OredevPlus.vue